import React from 'react';
import ProductBlock from 'shared/components/likiee/ProductBlock';
import Masonry from 'react-masonry-css';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import { API, graphqlOperation } from 'aws-amplify';
import { FolderIconFilled, TrashIconFilled, ZoomIcon } from 'shared/components/Icons';
import { removeProductModal } from 'shared/utils/productHelpers';
import { CreditOperation } from 'hooks/useCredits';
import { updateLikieeMutation } from 'graphql/likiees/mutations';
import CreditGatedAction from 'shared/components/Credits/CreditGatedAction';

const ProductList = ({
  products,
  onClickProductProject,
  selectedProducts,
  setSelectedProducts,
  isOnOrganizeState,
  onProductRemoveSuccess,
}) => {
  const { t } = useTranslation();
  const alert = useAlert();

  const onProductRemove = product => {
    removeProductModal(product, alert, t, onProductRemoveSuccess);
  };

  const performVisualSearch = async product => {
    try {
      // Perform visual search mutation
      await API.graphql(
        graphqlOperation(updateLikieeMutation, {
          input: {
            id: product.id,
            visualSearchRequested: true,
          },
        }),
      );

      alert.success(t('visual_search_started'));
    } catch (error) {
      console.error('Visual search error:', error);
      alert.error(t('visual_search_failed'));
    }
  };

  const onSelectProduct = item => {
    const tempProducts = [...selectedProducts];
    if (tempProducts.includes(item.id)) {
      tempProducts.splice(tempProducts.indexOf(item.id), 1);
    } else {
      tempProducts.push(item.id);
    }
    setSelectedProducts(tempProducts);
  };

  if (!products?.items) return null;

  return (
    <Masonry
      breakpointCols={{
        default: 4,
        1100: 3,
        500: 2,
      }}
      className='recomended-items-grid pl-6 pl-md-0'
      columnClassName='recomended-items-grid-column'
    >
      {products?.items?.map((item, i) => {
        const isSelected = selectedProducts.includes(item.id);
        const actionButtons = [
          { logo: <TrashIconFilled />, onClick: onProductRemove.bind(null, item) },
          { logo: <FolderIconFilled />, onClick: onClickProductProject.bind(null, item) },
          {
            customComponent: (
              <CreditGatedAction
                operation={CreditOperation.VISUAL_SEARCH}
                creditsRequired={1}
                referenceId={item.id}
                onAction={() => performVisualSearch(item)}
              >
                <ZoomIcon />
              </CreditGatedAction>
            ),
          },
        ];
        return (
          <ProductBlock
            product={item}
            key={i}
            actionButtons={actionButtons}
            showAlarm={true}
            showDate={true}
            notAvailable={item.availability === 'OutOfStock'}
            hideProductClick={isOnOrganizeState}
            onSelectToggle={isOnOrganizeState ? onSelectProduct.bind(null, item) : null}
            selected={!!isSelected}
            isCheckbox
          />
        );
      })}
    </Masonry>
  );
};

export default ProductList;
